<template>
    <div class="grid w-full grid-cols-3 col-gap-8 p-8 bg-output-gray-200 ">
        <div class="col-span-1 ">
            <h1 class="text-2xl font-semibold text-left text-output-secondary">
                {{ entreprise.name }}
            </h1>

            <div class="mt-2">
                <h4 class="text-lg font-medium leading-6 text-gray-900">
                    Description du projet
                </h4>
                <p class="mt-2 text-base leading-6 text-gray-500">
                    {{ project.description }}
                </p>
            </div>
        </div>
        <div class="grid grid-cols-3 col-span-2 ">
            <div class="p-2">
                <div
                    class="flex items-center justify-center w-12 h-12 rounded-md text-output-blue-300 bg-output-primary"
                >
                    <i class="las la-pen-nib la-2x text-output-secondary"></i>
                </div>
                <div class="mt-4">
                    <h4 class="text-lg font-medium leading-6 text-gray-900">
                        Titre du projet
                    </h4>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                        {{ project.title }}
                    </p>
                </div>
            </div>
            <div class="p-2">
                <div
                    class="flex items-center justify-center w-12 h-12 rounded-md text-output-blue-300 bg-output-primary"
                >
                    <i class="las la-pen la-2x text-output-secondary"></i>
                </div>
                <div class="mt-4">
                    <h4 class="text-lg font-medium leading-6 text-gray-900">
                        Société créée
                    </h4>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                        {{ entreprise.isCreated }}
                    </p>
                </div>
            </div>
            <div class="p-2">
                <div
                    class="flex items-center justify-center w-12 h-12 rounded-md text-output-blue-300 bg-output-primary"
                >
                    <i
                        class="las la-comments-dollar la-2x text-output-secondary"
                    ></i>
                </div>
                <div class="mt-4">
                    <h4 class="text-lg font-medium leading-6 text-gray-900">
                        Capital Social
                    </h4>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                        {{ formatPrice(entreprise.capitalSocial) }} DH
                    </p>
                </div>
            </div>
            <div class="p-2">
                <div
                    class="flex items-center justify-center w-12 h-12 rounded-md text-output-blue-300 bg-output-primary"
                >
                    <i class="las la-gavel la-2x text-output-secondary"></i>
                </div>
                <div class="mt-4">
                    <h4 class="text-lg font-medium leading-6 text-gray-900">
                        Forme juridique
                    </h4>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                        {{ entreprise.legalForm }}
                    </p>
                </div>
            </div>
            <div class="p-2">
                <div
                    class="flex items-center justify-center w-12 h-12 rounded-md text-output-blue-300 bg-output-primary"
                >
                    <i
                        class="las la-calendar-day text-output-secondary la-2x"
                    ></i>
                </div>
                <div class="mt-4">
                    <h4 class="text-lg font-medium leading-6 text-gray-900">
                        Date de création
                    </h4>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                        {{ date }}
                    </p>
                </div>
            </div>

            <div class="p-2">
                <div
                    class="flex items-center justify-center w-12 h-12 rounded-md text-output-blue-300 bg-output-primary"
                >
                    <i
                        class="las la-project-diagram text-output-secondary la-2x"
                    ></i>
                </div>
                <div class="mt-4">
                    <h4 class="text-lg font-medium leading-6 text-gray-900">
                        Activité
                    </h4>
                    <p class="mt-2 text-base leading-6 text-gray-500">
                        {{ getActivity(project.activity) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { OutputHelpers } from "@/mixins/OutputMixin.js";

export default {
    mixins: [OutputHelpers],

    props: {
        entreprise: {
            type: Object,
            required: true
        },
        project: {
            type: Object,
            required: true
        }
    },
    computed: {
        getActivity() {
            return id =>
                this.$store.state.forms.VotreProject.Sectors.filter(
                    elem => elem.value == id
                )[0].text;
        },
        date() {
            return new Date(
                this.entreprise.creationDate.seconds * 1000
            ).toLocaleDateString("fr-fr") !== "Invalid Date"
                ? new Date(
                      this.entreprise.creationDate.seconds * 1000
                  ).toLocaleDateString("fr-fr")
                : "---";
        }
    }
};
</script>

<style></style>
